import React from 'react';
import type { Props } from '..';

const AI: React.FCC<Props> = ({
  color = 'currentColor',
  strokeWidth = 3,
  ...props
}) => (
  <svg
    width="28"
    height="27"
    viewBox="0 0 28 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.11808 25.2019C9.65866 26.2661 11.1898 26.2661 11.7303 25.2019L13.6258 21.4706C14.1284 20.4814 14.8525 19.6194 15.7427 18.9508L19.2685 16.3027C20.0417 15.7219 20.0417 14.5688 19.2685 13.988L15.7427 11.3399C14.8525 10.6713 14.1284 9.80934 13.6258 8.82007L11.7303 5.08886C11.1898 4.02472 9.65866 4.02472 9.11808 5.08886L7.2226 8.82007C6.72005 9.80934 5.99596 10.6713 5.10576 11.3399L1.57993 13.988C0.80669 14.5688 0.80669 15.7219 1.57993 16.3027L5.10576 18.9508C5.99596 19.6194 6.72005 20.4814 7.2226 21.4706L9.11808 25.2019ZM22.7394 7.77625C23.1468 8.59443 24.3228 8.59443 24.73 7.77625C25.1041 7.02512 25.6459 6.36855 26.3144 5.8565L26.4925 5.71998C27.1692 5.20155 27.1692 4.18833 26.4925 3.6699L26.3144 3.53338C25.6459 3.02134 25.1041 2.36476 24.73 1.61364C24.3228 0.795455 23.1468 0.795455 22.7394 1.61364C22.3653 2.36476 21.8236 3.02134 21.1553 3.53338L20.977 3.6699C20.3004 4.18833 20.3004 5.20155 20.977 5.71998L21.1553 5.8565C21.8236 6.36855 22.3653 7.02512 22.7394 7.77625Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinejoin="round"
    />
  </svg>
);

export default AI;
